export class ListSubnetsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnetIds",
            "baseName": "subnetIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSubnetsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
